exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Gilroy';\n  font-style: normal;\n  src: url(" + require("./assets/fonts/gilroy/Gilroy-Regular.woff") + ") format(\"woff\"); }\n\nhtml, #root {\n  height: 100%;\n  width: 100%; }\n\nbody {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  font-family: Gilroy, serif; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/App.scss
// module id = 375
// module chunks = 0